import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "empty-state"
}

import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonItem, IonList, IonRadio, IonRadioGroup, IonTitle, IonToolbar, modalController } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { closeOutline, saveOutline } from "ionicons/icons";
import { translate } from "@hotwax/dxp-components";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomFrequencyModal',
  setup(__props) {

const store = useStore();

const customFrequencies = ref([]) as any;
const frequencyId = ref("");

onMounted(() => {
  findFrequencies();
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

async function findFrequencies() {
  customFrequencies.value = await store.dispatch("channel/findTemporalExpression");
}

async function setFrequency() {
  modalController.dismiss({ dismissed: true, frequencyId: frequencyId.value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(closeOutline),
                      slot: "icon-only"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Custom frequency")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        (customFrequencies.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRadioGroup), {
                    modelValue: frequencyId.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((frequencyId).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFrequencies.value, (customFrequency) => {
                        return (_openBlock(), _createBlock(_unref(IonItem), {
                          key: customFrequency.tempExprId
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonRadio), {
                              value: customFrequency.tempExprId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(customFrequency.description), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)("No frequency found.")), 1)
            ]))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFab), {
      vertical: "bottom",
      horizontal: "end",
      slot: "fixed"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonFabButton), {
          disabled: !frequencyId.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setFrequency()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ], 64))
}
}

})